import {
	completeStage,
	selectStage,
	skipStage,
} from '../../redux/slices/stageSlice';
import { display, selectSession } from '../../redux/slices/sessionSlice';
import { fetchPaymentPayload, SaveTransaction } from '../../redux/api';
import { getIolPay, initIolPay } from './iOLpay';
import {
	getReservationFromPMS,
	selectTnc,
} from '../../redux/slices/termsAndConditions';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hook';

import { DarkButton } from '../../components/dark-button';
import language from '@adyen/adyen-web/dist/types/language';
import Loading from '../../components/loading';
import { Modal } from 'react-bootstrap';
import { selectPayment } from './../../redux/slices/paymentSlice';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';
import useState from 'react-usestateref';

export const IolPaymentForm = () => {
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const [searchParams] = useSearchParams();
	const [refNo, setRefNo] = useState('');

	const dispatch = useAppDispatch();
	const { stages, stage } = useAppSelector(selectStage);
	const { skipPayment } = useAppSelector(selectPayment);
	const [__, setTotalPay, TotalPay] = useState(0.0);

	const [___, setIsButtonShow, isButtonShow] = useState(true);
	const [____, setLoading, loading] = useState(false);

	const { reservationDtl, loadingReservation } = useAppSelector(selectTnc);
	// useEffect(() => {
	// 	console.log('searchParams', searchParams.get('confirmationNumber'));
	// 	const confNo =
	// 		searchParams.get('confirmationNumber') === undefined ||
	// 		searchParams.getr('confirmationNumber') === null
	// 			? searchParams.get('reservation')
	// 			: searchParams.get('confirmationNumber');

	// 	setConfirmNo(confNo ?? '');
	// }, [searchParams]);

	const [formData, setFormData] = useState({
		payerName: '',
		payerEmail: '',
		payerAddress: '',
		payerCity: '',
		payerCountry: '',
		payerPostCode: '',
		currency: 'USD',
		country: 'AE',
		amount: 10,
		description: 'description',
		statementSuffix: 'Hotel name',
		checkInDate: '',
		checkOutDate: '',
		transactionId: '',
		referenceNo: '',
		userKey: 'b65060ee-f38f-424a-a010',
		merchantPubKey: '577918acqpqwkdrqtt7u99sdgsd8mhy3',
		orderDate: new Date().toISOString(),
		mode: 'Payment',
	});
	useEffect(() => {
		const txnId = new Date().getTime();
		setFormData((prevState: any) => ({
			...prevState,
			transactionId: txnId,
			referenceNo: txnId,
		}));
	}, []);

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};
	useEffect(() => {
		if (skipPayment) {
			dispatch(
				skipStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
				})
			);
		}
	}, [skipPayment]);

	useEffect(() => {
		setLoading(true);
		if (reservation?.PmsConfirmationNo && token) {
			dispatch(
				getReservationFromPMS({
					token,
					confirmationNo: reservation.PmsConfirmationNo,
				})
			)
				.unwrap()
				.then(() => {
					fetchPayment();
				});
			//console.log('after reservation fetch' + TotalPay.current);
		}
	}, [reservation?.PmsConfirmationNo, token]);
	useEffect(() => {
		if (reservationDtl) {
			setTotalPay(
				parseFloat(reservationDtl?.balanceAmount ?? 0) +
					parseFloat(reservationDtl?.totalAmount)
			);
			//alert(TotalPay?.current + '');
		}
		//console.log('after amount' + TotalPay.current);
	}, [reservationDtl]);

	// useEffect(() => {
	// 	// Initialize window.iolpay
	// 	if (
	// 		reservation !== null &&
	// 		reservation !== undefined &&
	// 		reservation?.PmsConfirmationNo !== ''
	// 	)

	// }, [reservation]);

	const fetchPayment = async () => {
		setLoading(true);

		if (TotalPay?.current > 0) {
			console.log('TOtal Amount  *****************', TotalPay?.current);
			const response = await fetchPaymentPayload(
				token,
				reservation?.PmsConfirmationNo,
				reservation?.ReservationNameID,
				TotalPay?.current
			);
			if (response !== null && response?.data?.result === true) {
				if (response?.data?.data?.paymentDetails?.amount > 0) {
					/* eslint-disable no-debugger */
					// debugger;
					/* eslint-enable no-debugger */
					console.log('run');
					setTimeout(() => {
						initIolPay();
						getIolPay()?.init(response?.data?.data);
						setRefNo(response?.data?.data?.referenceNo);
						window.addEventListener('message', receiveMessage);
						setLoading(false);

						console.log('ran');
					}, 3000);
					console.log('passed');
				} else {
					setLoading(true);

					dispatch(
						completeStage({
							token: token,
							stageID: stage?.stepID,
							ReservationID: reservation?.ReservationID,
							type: 'checkin',
							confirmationNo: reservation?.PmsConfirmationNo,
							stages: stages,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
						})
					)
						.unwrap()
						.then(() => {
							setLoading(false);
						});
					dispatch(display(true));
				}
			}
		} else {
			console.log(
				'TOtal Amount else part  *****************',
				TotalPay?.current
			);
			setLoading(true);

			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			)
				.unwrap()
				.then(() => {
					setLoading(false);
				});
			dispatch(display(true));
		}
	};
	const handleSubmit = (e: any) => {
		/* eslint-disable no-debugger */
		// debugger;
		/* eslint-enable no-debugger */
		e.preventDefault();

		const paymentSettings = {
			language: 'EN',
			merchantPubKey: formData.merchantPubKey,
			userKey: formData.userKey,
			transactionId: formData.transactionId,
			referenceNo: formData.referenceNo,
			payerDetails: {
				payerName: formData.payerName,
				payerCountry: formData.payerCountry,
				payerEmail: formData.payerEmail,
				payerAddress: formData.payerAddress,
			},
			paymentDetails: {
				referenceNo: formData.referenceNo,
				currency: formData.currency,
				country: formData.country,
				amount: formData.amount,
				orderDate: formData.orderDate,
				description: formData.description,
				mode: 'Payment',
				statementSuffix: formData.statementSuffix,
			},
			returnUrlSuccess: 'https://sandbox-portal.iolpay.com/Portal-Live/Auth',
			returnUrlCancel: '',
		};

		// window.iolpay.init({
		//     ...paymentSettings,
		//     merchantPubKey: formData.merchantPubKey,
		//     language: 'EN',
		//     userKey: formData.merchantUserKey
		// });

		const payload = {
			//methods: ['init', 'onResponse', 'submitPayment'],
			...paymentSettings,
			merchantPubKey: formData.merchantPubKey,
			language: 'EN',
		};
		initIolPay();
		getIolPay()?.init(payload);
	};

	const receiveMessage = async (event: any) => {
		/* eslint-disable no-debugger */
		// debugger;
		/* eslint-enable no-debugger */
		console.log('received json==' + JSON.stringify(event));
		console.log('received' + event.data?.value?.transactionId);

		// You can add more logic here to handle the received message
		if (event.data != null) {
			if (
				event.data.type === 'ON_SUCCESS' &&
				event.data.value.status === 'Succeeded'
			) {
				setLoading(true);
				const response = await SaveTransaction(token, {
					pmsConfirmationNo: reservation?.PmsConfirmationNo,
					reservationID: reservation?.ReservationID,
					ReferenceNo: event.data?.value?.transactionId,
				});
				console.log(JSON.stringify(response));
				if (response?.status === 200) {
					dispatch(
						completeStage({
							token: token,
							stageID: stage?.stepID,
							ReservationID: reservation?.ReservationID,
							type: 'checkin',
							confirmationNo: reservation?.PmsConfirmationNo,
							stages: stages,
							propertyCode: propertyInfo?.propertyCode ?? '', //added new
						})
					)
						.unwrap()
						.then(() => {
							setLoading(false);
						});
					dispatch(display(true));
				}
				// alert('payment success');
			}
			if (
				event.data.type === 'ON_SUCCESS' &&
				event.data.value.status === 'RequiresAction'
			) {
				setIsButtonShow(false);
			}
			if (
				event.data.type === 'INVALID_FORM' &&
				event.data.value.status === 'Form has not been validated.'
			) {
				setIsButtonShow(true);
			}

			// else {
			// 	Swal.fire({
			// 		icon: 'error',
			// 		title: 'Oops...',
			// 		text: 'Unsuccessful payment. Please try again!',
			// 	});
			// }
		}
	};

	return (
		<>
			{/* {loading?.current === true ? (
				<Loading />
			
			)
			 */}
			<>
				{loading?.current === true && (
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							// background: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white background
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							zIndex: 1000, // Ensures it appears on top
						}}>
						<Loading />
					</div>
				)}
				<div
					className="d-flex flex-column gap-4 vh-100 mx-auto justify-content-between"
					style={{ paddingBottom: '110px', overflow: 'auto' }}>
					<div className="d-flex flex-column gap-4">
						<div
							className="d-flex flex-column gap-2 align-items-center justify-content-center py-2 text-white theme-header"
							style={{ minHeight: '80px', background: '#03355C' }}>
							<div className="d-flex flex-column align-items-center">
								<p className="fs-2 m-0">Payment</p>
							</div>
						</div>
						<div className="px-3 d-flex flex-column gap-4 mt-2">
							<div className="d-flex flex-column gap-2 align-items-center justify-content-center w-100 py-2">
								<div className="modalPay" id="modalPay"></div>
								<div className="row" style={{ display: 'none' }}>
									<div className="col-6">
										<input
											type="button"
											id="btnSubmitPayment"
											value="Pay Now"
											className="ms_prod_link"
											onClick={() => {
												getIolPay()?.submitPayment();
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					className="fixed-bottom w-100 px-5 pb-4 pt-1 border-top d-flex flex-row justify-content-center theme-footer"
					style={{ backgroundColor: 'white', borderColor: 'gray' }}>
					{reservation?.PmsConfirmationNo &&
						refNo !== '' &&
						refNo !== undefined &&
						refNo !== null &&
						isButtonShow?.current === true && (
							<DarkButton
								text="Pay"
								onClick={() => {
									getIolPay()?.submitPayment();
								}}
								filled
							/>
						)}
				</div>
			</>
			{/* : (
				<></>
			)} */}
		</>
	);
};

export default IolPaymentForm;
